import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IntellioHttpResponse, VehicleToGridInfo } from '@intellio/shared/models';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({ providedIn: 'root' })
export class VehicleToGridInfoService extends BaseService {
  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getVehicleToGridInfo(): Observable<IntellioHttpResponse<VehicleToGridInfo[]>> {
    return this.get<VehicleToGridInfo[]>('/api/vehicletogridinfo');
  }
}
